import { memo } from 'react'
import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import ProgressiveDisclosed from 'components/ProgressiveDisclosed'
import { Typography } from '@mui/material'
import { useFormState } from 'react-final-form'
import { progressiveDisclosureValidator, VALIDATOR_EMAIL } from 'validation'

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    legal: {
      width: '100%',
      marginTop: theme.spacing(2),
      marginLeft: '4px'
    }
  })
)

const Note = ({ contact }: React.PropsWithChildren<{ contact: string }>) => {
  const { values } = useFormState()
  const primaryDebtorData = values.debtors.primary
  const { legal } = useStyles()

  return (
    <ProgressiveDisclosed
      value={primaryDebtorData?.contact?.email}
      validator={progressiveDisclosureValidator(VALIDATOR_EMAIL)}
      disableDisclose
    >
      <Typography className={legal} variant="caption">
        {`Wir versenden Informationen und Umfragen zu unserer
              Dienstleistung unter Verwendung elektronischer Post. Dem
              Erhalt kann ich jederzeit per E-Mail an ${contact}
              widersprechen.`}
      </Typography>
    </ProgressiveDisclosed>
  )
}

export default memo(Note)
